export default __webpack_public_path__ + "static/social-clusters_en-592d423ad2c6fa0a9a36329959a60bba.png";